/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useDispatch} from 'react-redux';
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";
import {useEffect} from "react";

export default function TabletDevice() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setRuleConfig(
			{
				id: 'TabletDevice',
				config: {
					ruleType: "device",
					args: {
						devices: ["tablet"],
					},
				}
			}
		));
	}, []);

	return <>
		<p>
			This
			rule
			targets
			tablet
			devices.
		</p>
	</>;
}
